import { observer } from 'mobx-react-lite';
import { CheckCircle, Info, X, XCircle } from '@phosphor-icons/react';
import { useResolve } from '@/infrastructure/useResolve';
import { useT } from './useT';
import { TOKEN_ToastStore } from './ToastStore';

const ICON = {
  success: <CheckCircle weight="fill" className="text-light-green" size={16} />,
  error: <XCircle weight="fill" className="text-light-red" size={16} />,
  info: <Info weight="fill" className="text-amber-signal" size={16} />,
};

const BORDER: Record<string, string> = {
  success: 'border-light-green',
  error: 'border-light-red',
  info: 'border-amber-signal',
};

export const ToastView = observer(function ToastView() {
  const store = useResolve(TOKEN_ToastStore);
  const t = useT();
  if (store.toasts.length === 0) return null;
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 flex flex-col gap-2">
      {store.toasts.map((toast) => (
        <div
          key={toast.id}
          className={`pointer-events-auto flex min-w-[260px] items-start gap-2 border-l-4 bg-white px-3 py-2 font-mono text-xs shadow-lg dark:bg-steel-800 ${BORDER[toast.kind]}`}
        >
          {ICON[toast.kind]}
          <span className="flex-1">{toast.message}</span>
          <button
            type="button"
            onClick={() => store.dismiss(toast.id)}
            className="text-steel-400 hover:text-steel-700 dark:hover:text-steel-200"
            aria-label={t.toasts.dismiss}
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
});
